export const RoleEnum = {
    admin: 'Administrator',
    vip: 'VIP',
    supplier: 'Supplier',
}
